import { useEffect } from 'react';
import { useKnowledgeStore } from '@/stores/knowledge';

export function ResolutionStats() {
  const { stats, statsLoading, fetchStats } = useKnowledgeStore();

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  if (statsLoading) {
    return (
      <div className="flex items-center gap-6 px-5 py-2.5 bg-white border-t border-slate-200 text-sm text-slate-400">
        Loading stats...
      </div>
    );
  }

  if (!stats) return null;

  return (
    <div className="flex items-center gap-6 px-5 py-2.5 bg-white border-t border-slate-200 text-sm">
      <StatBadge label="Total" value={stats.total_canonicals} color="teal" />
      <StatBadge label="Avg Confidence" value={`${(stats.avg_confidence * 100).toFixed(1)}%`} color="green" />
      <StatBadge label="Avg Sources" value={stats.avg_source_count.toFixed(1)} color="purple" />
      <StatBadge label="Edges" value={stats.total_edges} color="orange" />
      <StatBadge label="Resolutions" value={stats.total_resolution_results} color="gray" />
      {stats.by_entity_type && Object.keys(stats.by_entity_type).length > 0 && (
        <div className="ml-auto flex items-center gap-3 text-slate-400">
          {Object.entries(stats.by_entity_type).slice(0, 4).map(([type, count]) => (
            <span key={type} className="text-xs">{type}: <span className="text-slate-600 font-medium">{count}</span></span>
          ))}
        </div>
      )}
    </div>
  );
}

function StatBadge({ label, value, color }: { label: string; value: string | number; color: string }) {
  const colorClasses: Record<string, string> = {
    teal: 'text-brand-teal',
    green: 'text-emerald-600',
    purple: 'text-violet-600',
    orange: 'text-amber-600',
    gray: 'text-slate-500',
  };

  return (
    <div className="flex items-center gap-1.5">
      <span className="text-slate-400 text-xs">{label}:</span>
      <span className={`font-semibold text-sm ${colorClasses[color] || 'text-slate-700'}`}>{value}</span>
    </div>
  );
}
